import progressBar from './progress-bar.json' with { type: 'json' };
import sparkjsUpgradeAlert from './sparkjs-upgrade-alert.json' with { type: 'json' };

export default {
  progress_bar: progressBar,
  sparkjs_upgrade_alert: sparkjsUpgradeAlert,
};
